/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrossModuleActionContextRequest
 */
export interface CrossModuleActionContextRequest {
    /**
     * 
     * @type {string}
     * @memberof CrossModuleActionContextRequest
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossModuleActionContextRequest
     */
    entityId?: string;
}

/**
 * Check if a given object implements the CrossModuleActionContextRequest interface.
 */
export function instanceOfCrossModuleActionContextRequest(value: object): value is CrossModuleActionContextRequest {
    return true;
}

export function CrossModuleActionContextRequestFromJSON(json: any): CrossModuleActionContextRequest {
    return CrossModuleActionContextRequestFromJSONTyped(json, false);
}

export function CrossModuleActionContextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrossModuleActionContextRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
    };
}

export function CrossModuleActionContextRequestToJSON(json: any): CrossModuleActionContextRequest {
    return CrossModuleActionContextRequestToJSONTyped(json, false);
}

export function CrossModuleActionContextRequestToJSONTyped(value?: CrossModuleActionContextRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': value['entityType'],
        'entityId': value['entityId'],
    };
}

